export default {
  en: {
    footerComp: {
      tagline: "Election Results Management System",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      cookie: "Cookie Policy",
      refund: "Refund Policy",
      disclaimer: "Independent platform. Not affiliated with, endorsed by, or operated by ELECAM, the Constitutional Council or any government body. Official results are cited from published sources."
    }
  },
  fr: {
    footerComp: {
      tagline: "Système de gestion des résultats électoraux",
      privacy: "Politique de confidentialité",
      terms: "Conditions d'utilisation",
      cookie: "Politique relative aux cookies",
      refund: "Politique de remboursement",
      disclaimer: "Plateforme indépendante. Non affiliée à ELECAM, au Conseil constitutionnel ou à tout organisme public, et ni approuvée ni exploitée par eux. Les résultats officiels sont cités à partir de sources publiées."
    }
  }
};
